let navigator

export const setNavigator = (nav) => {
   navigator = nav
}

export const navigate = (url, options) => {
    navigator(url, options)
}